(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewsCarousel {
    constructor(carouselWrapper) {
      this.wrapper = carouselWrapper;
      this.carouselId = carouselWrapper.getAttribute('data-carousel-id');
      this.currentSlide = 0;
      this.isMobile = window.innerWidth < 750;
      this.slidesToShow = this.isMobile ? 1.5 : 3;
      this.slideWidth = 100 / this.slidesToShow;
      
      // Autoplay settings
      this.autoplay = carouselWrapper.getAttribute('data-autoplay') === 'true';
      this.autoplaySpeed = parseInt(carouselWrapper.getAttribute('data-autoplay-speed')) || 3000;
      this.autoplayInterval = null;
      this.isPaused = false;
      
      // Cache computed values to avoid reflow
      this.cachedGap = null;
      this.cachedCardWidth = null;
      
      this.init();
    }
    
    init() {
      // Create carousel structure
      const cards = Array.from(this.wrapper.querySelectorAll('.review-card'));
      if (cards.length === 0) return;
      
      // Remove old structure if exists
      const oldInner = this.wrapper.querySelector('.carousel-inner');
      if (oldInner) oldInner.remove();
      
      // Create inner container
      const inner = document.createElement('div');
      inner.className = 'carousel-inner';
      
      // Create track
      const track = document.createElement('div');
      track.className = 'carousel-track';
      
      // Move cards into track
      cards.forEach(card => {
        track.appendChild(card);
      });
      
      inner.appendChild(track);
      // Append at the end to avoid DOM reflow issues and unwanted scroll
      this.wrapper.appendChild(inner);
      
      // Store references
      this.track = track;
      this.inner = inner;
      this.cards = this.wrapper.querySelectorAll('.review-card');
      this.totalSlides = this.cards.length;
      
      // Attach event listeners
      this.attachEventListeners();
      this.updateCarousel();
      
      // Start autoplay if enabled
      if (this.autoplay) {
        this.startAutoplay();
        
        // Pause on hover
        this.wrapper.addEventListener('mouseenter', () => {
          this.pauseAutoplay();
        });
        
        this.wrapper.addEventListener('mouseleave', () => {
          this.resumeAutoplay();
        });
      }
    }
    
    attachEventListeners() {
      // Previous button (::before pseudo)
      this.wrapper.addEventListener('click', (e) => {
        if (e.target === this.wrapper || e.target.closest('.customer-reviews-carousel-wrapper::before')) {
          this.prev();
        }
      });
      
      // Next button (::after pseudo)
      this.wrapper.addEventListener('click', (e) => {
        if (e.target === this.wrapper || e.target.closest('.customer-reviews-carousel-wrapper::after')) {
          this.next();
        }
      });
      
      // Create actual buttons
      const prevBtn = document.createElement('button');
      prevBtn.className = 'carousel-btn carousel-btn--prev';
      prevBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 19l-7-7 7-7"/></svg>';
      prevBtn.addEventListener('click', () => this.prev());
      
      const nextBtn = document.createElement('button');
      nextBtn.className = 'carousel-btn carousel-btn--next';
      nextBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 5l7 7-7 7"/></svg>';
      nextBtn.addEventListener('click', () => this.next());
      
      this.wrapper.appendChild(prevBtn);
      this.wrapper.appendChild(nextBtn);
      
      this.prevBtn = prevBtn;
      this.nextBtn = nextBtn;
      
      // Touch/swipe support
      this.addTouchSupport();
      
      window.addEventListener('resize', () => this.handleResize());
    }
    
    addTouchSupport() {
      let startX = 0;
      let startY = 0;
      let isDragging = false;
      let isSwiping = false;
      
      this.inner.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
        isSwiping = false;
        // Pause autoplay when user starts touching
        this.pauseAutoplay();
      }, { passive: true });
      
      this.inner.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        
        const deltaX = Math.abs(e.touches[0].clientX - startX);
        const deltaY = Math.abs(e.touches[0].clientY - startY);
        
        // If horizontal swipe is more significant than vertical, mark as swiping
        if (deltaX > deltaY && deltaX > 10) {
          isSwiping = true;
          e.preventDefault();
        }
      }, { passive: false });
      
      this.inner.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        
        const endX = e.changedTouches[0].clientX;
        const endY = e.changedTouches[0].clientY;
        const deltaX = startX - endX;
        const deltaY = startY - endY;
        
        // Only process horizontal swipes
        if (isSwiping && Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
          e.preventDefault();
          if (deltaX > 0) {
            this.next(); // Swipe left -> next
          } else {
            this.prev(); // Swipe right -> prev
          }
        }
        
        isDragging = false;
        isSwiping = false;
        // Resume autoplay when touch ends
        this.resumeAutoplay();
      }, { passive: false });
    }
    
    handleResize() {
      const wasDesktop = this.slidesToShow === 3;
      const isDesktop = window.innerWidth >= 750;
      
      if (wasDesktop !== isDesktop) {
        this.isMobile = !isDesktop;
        this.slidesToShow = isDesktop ? 3 : 1.5;
        this.slideWidth = 100 / this.slidesToShow;
        this.currentSlide = 0;
        // Clear cache on resize
        this.cachedCardWidth = null;
        this.updateCarousel();
      }
    }
    
    prev() {
      this.currentSlide = Math.max(0, this.currentSlide - 1);
      this.updateCarousel();
    }
    
    next() {
      const maxSlide = this.totalSlides - Math.floor(this.slidesToShow);
      this.currentSlide = Math.min(maxSlide, this.currentSlide + 1);
      this.updateCarousel();
    }
    
    updateCarousel() {
      // Use requestAnimationFrame to batch DOM operations
      requestAnimationFrame(() => {
        if (!this.cachedGap) {
          this.cachedGap = parseFloat(getComputedStyle(this.wrapper).getPropertyValue('--cards-gap')) || 16;
        }
        
        if (!this.cachedCardWidth && this.track.children[0]) {
          this.cachedCardWidth = this.track.children[0].offsetWidth;
        }
        
        const cardWidth = this.cachedCardWidth || 0;
        const totalWidth = (cardWidth + this.cachedGap) * this.currentSlide;
        this.track.style.transform = `translateX(-${totalWidth}px)`;
        
        // Update button states
        if (this.prevBtn) {
          this.prevBtn.disabled = this.currentSlide === 0;
        }
        if (this.nextBtn) {
          const maxSlide = this.totalSlides - Math.floor(this.slidesToShow);
          this.nextBtn.disabled = this.currentSlide >= maxSlide;
        }
      });
    }
    
    startAutoplay() {
      if (!this.autoplay || this.isPaused) return;
      
      this.autoplayInterval = setInterval(() => {
        if (!this.isPaused) {
          this.nextInfinite();
        }
      }, this.autoplaySpeed);
    }
    
    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }
    
    pauseAutoplay() {
      this.isPaused = true;
      this.stopAutoplay();
    }
    
    resumeAutoplay() {
      this.isPaused = false;
      if (this.autoplay) {
        this.startAutoplay();
      }
    }
    
    nextInfinite() {
      // Infinite loop: go to first slide when reaching the end
      if (this.currentSlide >= this.totalSlides - Math.floor(this.slidesToShow)) {
        this.currentSlide = 0;
      } else {
        this.currentSlide++;
      }
      this.updateCarousel();
    }
  }
  
  // Initialize all carousels
  function initCarousels() {
    document.querySelectorAll('[data-carousel-id]').forEach(wrapper => {
      new ReviewsCarousel(wrapper);
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }
  
  document.addEventListener('shopify:section:load', initCarousels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const faqItems = document.querySelectorAll('[data-faq-item]');
    
    faqItems.forEach(item => {
      const summary = item.querySelector('.faq-question');
      
      if (summary) {
        summary.addEventListener('click', function(e) {
          // El comportamiento nativo de details maneja la apertura/cierre
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-custom"] && !Shopify.designMode) return;
  try {
    
  class SlideshowCustom {
    constructor(section) {
      this.section = section;
      this.container = section.querySelector('.slideshow-custom-container');
      this.slides = section.querySelectorAll('.slideshow-custom__slide');
      this.prevBtn = section.querySelector('.slideshow-custom__arrow--prev');
      this.nextBtn = section.querySelector('.slideshow-custom__arrow--next');
      this.dots = section.querySelectorAll('.slideshow-custom__dot');
      this.currentIndex = 0;
      this.autoplaySpeed = parseInt(section.dataset.autoplaySpeed) || 5000;
      this.autoplay = section.dataset.autoplay === 'true';
      this.autoplayInterval = null;

      this.init();
    }

    init() {
      const hasOnlyOneSlide = this.slides.length <= 1;
      if (hasOnlyOneSlide) {
        this.prevBtn?.style.setProperty('display', 'none');
        this.nextBtn?.style.setProperty('display', 'none');
        const dotsContainer = this.section.querySelector('.slideshow-custom__dots');
        if (dotsContainer) {
          dotsContainer.style.setProperty('display', 'none');
        }
      }

      // Mostrar primer slide
      this.showSlide(0);

      // Event listeners
      this.prevBtn?.addEventListener('click', () => this.prevSlide());
      this.nextBtn?.addEventListener('click', () => this.nextSlide());

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.showSlide(index));
      });

      // Keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prevSlide();
        if (e.key === 'ArrowRight') this.nextSlide();
      });

      // Autoplay
      if (this.autoplay) {
        this.startAutoplay();
        this.section.addEventListener('mouseenter', () => this.stopAutoplay());
        this.section.addEventListener('mouseleave', () => this.startAutoplay());
      }
    }

    showSlide(index) {
      if (index >= this.slides.length) {
        this.currentIndex = 0;
      } else if (index < 0) {
        this.currentIndex = this.slides.length - 1;
      } else {
        this.currentIndex = index;
      }

      // Update slides
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.currentIndex);
      });

      // Update dots
      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-current', i === this.currentIndex ? 'true' : 'false');
      });
    }

    nextSlide() {
      this.showSlide(this.currentIndex + 1);
      if (this.autoplay) {
        this.resetAutoplay();
      }
    }

    prevSlide() {
      this.showSlide(this.currentIndex - 1);
      if (this.autoplay) {
        this.resetAutoplay();
      }
    }

    startAutoplay() {
      if (this.autoplay) {
        this.autoplayInterval = setInterval(() => this.nextSlide(), this.autoplaySpeed);
      }
    }

    stopAutoplay() {
      clearInterval(this.autoplayInterval);
    }

    resetAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.slideshow-custom-section');
    sections.forEach(section => {
      new SlideshowCustom(section);
    });
  });

  // Also handle dynamic section loading
  document.addEventListener('shopify:section:load', function(e) {
    const section = e.detail.target.querySelector?.('.slideshow-custom-section');
    if (section) {
      new SlideshowCustom(section);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
